import { commentsData } from "store/allData";
import EachComment from "./EachComment";
import SectionWrapper from "components/common/SectionWrapper";
import Heading from "components/common/Heading";

const Comments: React.FC = () => {
  return (
    <div className="w-full mx-auto flex flex-col justify-center items-center my-20 pt-10 pb-10">
      <SectionWrapper className="mx-auto flex flex-col justify-center items-center">
        <span className="eyebrow">Client feedback</span>
        <Heading className="text-3xl sm:text-4xl mt-4 text-center">
          People are talking
        </Heading>
        <p className="mt-4 max-w-xl text-center text-zinc-400">
          Verified reviews from clients we&apos;ve shipped with on Upwork.
        </p>
        <ul className="w-full lg:w-11/12 xl:w-10/12 mt-12 columns-1 md:columns-2 xl:columns-3 gap-5">
          {commentsData.map((data, index) => {
            return <EachComment key={data.name + index} {...data} />;
          })}
        </ul>
      </SectionWrapper>
    </div>
  );
};

export default Comments;
